import { render } from "./etkinlikForm.vue?vue&type=template&id=602215ca"
import script from "./etkinlikForm.vue?vue&type=script&lang=js"
export * from "./etkinlikForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__